export class AloProxy {
        
    public body:string

    constructor({body = ""} = {}) {
        this.body = body     
    }

    static createAloAloProxy(data:any) {
        return new AloProxy({...data,detailLoaded:true})
    }
}